"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/teamSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "0.2s" | "0.4s" | "0.6s" | "0.8s" */
    dataWowDelay: string;
    /** Detected variants: "work-wrap flex-fill" | "work-wrap work-02 flex-fill" | "work-wrap work-03 flex-fill" | "work-wrap work-04 flex-fill" */
    className: string;
    /** Detected variants: "Step 1" | "Step 2" | "Step 3" | "Step 4" */
    span1Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/work-01.jpg" | "/Templates/Doccure/img/service/work-02.jpg" | "/Templates/Doccure/img/service/work-03.jpg" | "/Templates/Doccure/img/service/work-04.jpg" */
    src: string;
    /** Detected variants: "Choose Your Service" | "Pick Date & Time" | "Enter Details" | "Confirm Your Booking" */
    h30Text: ReactNode;
    /** Detected variants: "Select the dermatology treatment you need skin consultation, acne treatment, hair care." | "Choose your preferred appointment date and time that fits your schedule easily." | "Fill in your basic information and describe your skin concern for better consultation." | "Review your details and confirm your appointment. Get instant confirmation and visit the clinic." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-sm-6 d-flex wow fadeInUp" */
    divClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "work-way" */
    div0ClassName?: string;
    /** Detected variants: "circle-icon" */
    span0ClassName?: string;
    /** Detected variants: "step" */
    span1ClassName?: string;
    /** Detected variants: "work-item-fourteen" */
    div1ClassName?: string;
    /** Detected variants: "work-img" */
    div0ClassName2?: string;
    /** Detected variants: "work" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "work-content" */
    div1ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeFourteenTeamSectionGeneratedProps = {
    divDiv0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "How Booking" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Process" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Works For You" */
    sectionDiv0Div0H20Span1SpanText?: ReactNode;
    sectionDiv0Div1Div0ClassName?: string;
    teamSection36FadeInUps: TeamSection36FadeInUpsItem[];
    teamSection36FadeInUpsItemWrapper?: (item: TeamSection36FadeInUpsItem, content: ReactNode) => ReactNode;
    teamSection36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsImageVisible?: boolean;
    teamSection36FadeInUpsImageRenderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsH3Visible?: boolean;
    teamSection36FadeInUpsH3Renderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourteenTeamSectionGenerated: FC<HomeFourteenTeamSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "How Booking",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Process",
    sectionDiv0Div0H20Span1SpanText = "Works For You",
    divDiv0Div1Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div1H30H3Props,
    sectionDiv0Div1Div0ClassName,
    teamSection36FadeInUps,
    teamSection36FadeInUpsItemWrapper,
    teamSection36FadeInUpsRenderer,
    teamSection36FadeInUpsImageVisible,
    teamSection36FadeInUpsImageRenderer,
    teamSection36FadeInUpsH3Visible,
    teamSection36FadeInUpsH3Renderer,
    teamSection36FadeInUpsImageProps,
    teamSection36FadeInUpsH3Props,
}) => {
    return (
        <section className="work-section-fourteen section">
            <div className="container">
                <div className="section-header section-header-fourteen text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span className="section-line">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                            <span className="subtitle">{sectionDiv0Div0H20Span1SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className="work-sec">
                    <div className={sectionDiv0Div1Div0ClassName ?? "row g-4"}>
                        {renderCollectionNode(
                            teamSection36FadeInUps,
                            (item: TeamSection36FadeInUpsItem) => (
                                <div className={item.divClassName ?? "col-xl-3 col-sm-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                    <div className={item.className}>
                                        <div className={item.div0ClassName ?? "work-way"}>
                                            <span className={item.span0ClassName ?? "circle-icon"} />
                                            <span className={item.span1ClassName ?? "step"}>{item.span1Text}</span>
                                        </div>
                                        <div className={item.div1ClassName ?? "work-item-fourteen"}>
                                            <div className={item.div0ClassName2 ?? "work-img"}>
                                                {renderItemNode(teamSection36FadeInUpsImageVisible, teamSection36FadeInUpsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "work"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof teamSection36FadeInUpsImageProps === "function" ? teamSection36FadeInUpsImageProps(item) : (teamSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div1Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div1Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div1Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                            <div className={item.div1ClassName2 ?? "work-content"}>
                                                {renderItemNode(teamSection36FadeInUpsH3Visible, teamSection36FadeInUpsH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof teamSection36FadeInUpsH3Props === "function" ? teamSection36FadeInUpsH3Props(item) : (teamSection36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div1Div1H30H3Props === "function" ? divDiv0Div1Div1H30H3Props(item) : (divDiv0Div1Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                ))}
                                                <p>{item.p0Text}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ),
                            teamSection36FadeInUpsItemWrapper,
                            teamSection36FadeInUpsRenderer
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFourteenTeamSectionGenerated;
